import React from "react";
import Commonheader from "./components/headers/Common";
import { useAuth } from "./contexts/Authcontext";
import BlueHeader from "./components/common/BlueHeader";

const Pro = () => {
  const { currentUser, userDocument } = useAuth();

  const handleLogin = async () => {
    window.location.href =
      "/login?referURL=" + encodeURIComponent(window.location.href);
  };

  return (
    <>
      <BlueHeader title="Pro" />
      <Commonheader page="Pro" />

      <div className="container pb-5">
        <div className="">
          {(userDocument && !userDocument.isPro) || !userDocument ? (
            <div className="featured-bg gray black border pl-2 pr-2">
              <div className="text-center pb-4 black">
                We're not accepting new Pro subscriptions at the moment, so it's
                not currently possible to sign up.
              </div>
              <div className="text-center pb-4 black">
                Existing Pro members are unaffected and keep all of the features
                below.
              </div>
              {!currentUser && (
                <div className="row d-flex justify-content-center ml-2 mr-2">
                  <div className="text-center pb-3 black">
                    Already a Pro member? Login to access your features.
                  </div>

                  <button
                    className="btn btn-ontheme btn-block"
                    onClick={handleLogin}
                  >
                    Login
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="featured-bg gray black border">
              <div className="text-center pb-1 pr-1 pl-1 black">
                Thanks for being a Pro Member! You can manage your subscription
                in your <a href="/profile">profile page</a>.
              </div>
            </div>
          )}

          <div className="pt-4"></div>
          <div className="featured-bg gray black">
            <div className="container black">
              <div className="row">
                <div className="align-self-center col-md-12 col-lg-6 pt-1">
                  <h3>Predicted Platforms</h3>
                  <p className="pt-1">
                    Beat the rush and find out what platform your train is
                    departing from before the general public.
                  </p>
                  <p className="d-none d-md-block pt-1">
                    When subscribed to Pro, you'll see predicted platforms up to
                    2 hours early.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6 pt-2">
                  <img
                    id="mockup-gif"
                    className="image-cap"
                    src="/img/pred_plat.png"
                    alt="Predicted platforms"
                  />
                </div>
                <div className="col-md-12 d-block d-md-none">
                  <p className="pt-2">
                    When subscribed to Pro, you'll see predicted platforms up to
                    2 hours early.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="featured-bg gray black">
            <div className="container black">
              <div className="row">
                <div className="align-self-center col-md-12 col-lg-6 pt-1">
                  <h3>Expanded Services</h3>
                  <p className="pt-1">
                    Click on any service to expand and see more information,
                    including Calling Points, and delay and cancellation
                    reasons.
                  </p>
                  <p className="d-none d-md-block pt-1">
                    Expanded Services also supports dividing and joining trains.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6 pt-2">
                  <img
                    id="mockup-gif"
                    className="image-cap"
                    src="/img/calling_points.png"
                    alt="Calling points"
                  />
                </div>
                <div className="col-md-12 d-block d-md-none">
                  <p className="pt-2">
                    Expanded Services also supports dividing and joining trains.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="featured-bg gray black">
            <div className="container black">
              <div className="row">
                <div className="align-self-center col-md-12 col-lg-6 pt-1">
                  <h3>Onboard Hub</h3>
                  <p className="pt-1">
                    Mark yourself as onboard a service, and access it from the
                    Onboard Hub where you can track your journey as it
                    progresses.
                    <br />
                    <br /> You can also share journeys with family and friends
                    so they can follow along.
                  </p>
                  <p className="d-none d-md-block pt-1">
                    Save the Onboard Hub to your homescreen for instant progress
                    updates.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6 pt-2">
                  <img
                    id="mockup-gif"
                    className="image-cap"
                    src="/img/onboard_hub.png"
                    alt="Onboard Hub"
                  />
                </div>
                <div className="col-md-12 d-block d-md-none">
                  <p className="pt-2">
                    Save the Onboard Hub to your homescreen for instant progress
                    updates.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="featured-bg gray black">
            <div className="container black">
              <div className="row">
                <div className="align-self-center col-md-12 col-lg-6 pt-1">
                  <h3>Favourites</h3>
                  <p className="pt-1">
                    Don't want an icon for every journey? Have just one with
                    Favourites.
                  </p>
                  <p className="d-none d-md-block pt-1">
                    Quickly access your journey in either direction with just
                    one tap.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6 pt-2">
                  <img
                    id="mockup-gif"
                    className="image-cap"
                    src="/img/favourites_hub.png"
                    alt="Favourites Hub"
                  />
                </div>
                <div className="col-md-12 d-block d-md-none">
                  <p className="pt-2">
                    Quickly access your journey in either direction with just
                    one tap.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="featured-bg gray black">
            <div className="container black">
              <div className="row">
                <div className="align-self-center col-12 pt-1 text-center">
                  <h3>And more...</h3>
                  <p>
                    <li className="pt-2">
                      {" "}
                      See the train operator in the journey view.
                    </li>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Pro;
